<template>
  <div class="p-postEditor__itemWrapper">
    <image-uploader-selecter
      :image-uploader-selecter="imageUploaderSelecter"
      :image-direct-url.sync="imageDirectUrl"
      @close-image-uploader-selecter="imageUploaderSelecter = false"
      @select-picture="updateImage"
      @upload-download-image="uploadDownloadImage"
      @upload-picture="uploadPicture"
    />
    <div v-show="editingItemIndex !== index" @click="editItem">
      <image-item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <v-row>
        <v-col lg="6">
          <div
            style="position: relative"
            class="p-postEditor__imageForm--display"
            @mouseover="imageItemOverlay = true"
            @mouseleave="imageItemOverlay = false"
          >
            <v-img
              :src="imageSource"
              height="300"
              contain
              @:error="changeImageSource"
            />
            <v-overlay absolute color="white" :value="imageItemOverlay">
              <v-btn
                class="ma-1"
                fab
                x-small
                @click.stop="imageUploaderSelecter = true"
              >
                <v-icon>mdi-cog</v-icon>
              </v-btn>
              <v-btn
                v-if="true"
                class="ma-1"
                color="error"
                fab
                x-small
                @click="deleteImage"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-overlay>
          </div>
        </v-col>
        <v-col lg="6">
          <v-text-field
            v-model="altAttribute"
            label="代替テキスト（alt属性）"
            autofocus
          />
          <v-text-field v-model="heading" label="画像見出し" />
          <v-textarea v-model="content" class="body-2" label="コンテンツ" />
          <v-text-field
            v-model="quoteUrl"
            type="url"
            :rules="[urlValidation]"
            label="引用元URL"
          />
        </v-col>
      </v-row>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import imageUtilsMixin from '@/mixins/image_utils'
import FormValidationUtilsMixin from '@/mixins/form_validation_utils'
import ImageUploaderSelecter from '../parts/ImageUploaderSelecter'
import ImageItemPreview from './previews/ImageItemPreview'

export default {
  name: 'ImageItem',
  components: {
    ImageItemPreview,
    ImageUploaderSelecter
  },
  mixins: [itemUtilsMixin, imageUtilsMixin, FormValidationUtilsMixin],
  data: () => {
    return {
      imageItemOverlay: false,
      imageUploaderSelecter: false,
      failedFlg: false
    }
  },
  computed: {
    altAttribute: {
      get: function () {
        return this.editingItemable.altAttribute
      },
      set: function (value) {
        this.updateEditingItemable(value, 'altAttribute')
      }
    },
    content: {
      get: function () {
        return this.editingItemable.content
      },
      set: function (value) {
        this.updateEditingItemable(value, 'content')
      }
    },
    heading: {
      get: function () {
        return this.editingItemable.heading
      },
      set: function (value) {
        this.updateEditingItemable(value, 'heading')
      }
    },
    quoteUrl: {
      get: function () {
        return this.editingItemable.quoteUrl
      },
      set: function (value) {
        this.updateEditingItemable(value, 'quoteUrl')
      }
    },
    imageSource: function () {
      return this.failedFlg ? this.oldImageSource() : this.preSource()
    },
    imageDirectUrl: {
      get: function () {
        return this.editingItemable.imageDirectUrl
      },
      set: function (value) {
        this.updateEditingItemable(value, 'imageDirectUrl')
      }
    }
  },
  methods: {
    preSource () {
      if (this.$store.state.PostEditor.editingItemable.imageDirectUrl) {
        return this.$store.state.PostEditor.editingItemable.imageDirectUrl
      } else if (this.$store.state.PostEditor.editingItemable.imagableUrl) {
        return this.$store.state.PostEditor.editingItemable.imagableUrl
      } else {
        return `http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image`
      }
    },
    changeImageSource () {
      this.failedFlg = true
    },
    oldImageSource () {
      if (this.$store.state.PostEditor.editingItemable.imageDirectUrl) {
        this.updateEditingItemable(
          this.$store.state.PostEditor.editingItemable.imageDirectUrl,
          'imagableUrl'
        )
        return this.$store.state.PostEditor.editingItemable.imagableUrl
      } else if (this.$store.state.PostEditor.editingItemable.imagableUrl) {
        this.updateEditingItemable(
          this.$store.state.PostEditor.editingItemable.imagableUrl.replace(
            /fitMiddle/,
            'middle'
          ),
          'imagableUrl'
        )
        return this.$store.state.PostEditor.editingItemable.imagableUrl
      }
    },
    updateImage (picture) {
      let itemable = Object.assign({}, this.editingItemable)
      itemable.imagableId = picture.id
      itemable.imagableType = 'Picture'
      itemable.imagableUrl = picture.file.fitMiddle.url
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
      this.imageUploaderSelecter = false
    },
    uploadDownloadImage (downloadImage) {
      let itemable = Object.assign({}, this.editingItemable)
      itemable.imagableId = downloadImage.id
      itemable.imagableType = 'DownloadImage'
      itemable.imagableUrl = downloadImage.file.fitMiddle.url
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
      this.imageUploaderSelecter = false
    },
    uploadPicture (picture) {
      let itemable = Object.assign({}, this.editingItemable)
      itemable.imagableId = picture.id
      itemable.imagableType = 'Picture'
      itemable.imagableUrl = picture.file.fitMiddle.url
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
      this.imageUploaderSelecter = false
    },
    deleteImage () {
      let itemable = Object.assign({}, this.editingItemable)
      itemable.imagableId = null
      itemable.imagableType = null
      itemable.imagableUrl = null
      itemable.imageDirectUrl = null
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
    }
  }
}
</script>

<style scoped></style>
